import styled from 'styled-components';
import { createHandler } from '@mews/std';
import { FadeInCSS, FadeInDelayedCSS, SlideInFromLeftCSS, SlideInFromRightCSS } from './style';
import { TransitionName, TransitionProps } from './types';

const getTransitionStyles = createHandler(
    {
        [TransitionName.FadeIn]: FadeInCSS,
        [TransitionName.FadeInDelayed]: FadeInDelayedCSS,
        [TransitionName.SlideInFromLeft]: SlideInFromLeftCSS,
        [TransitionName.SlideInFromRight]: SlideInFromRightCSS,
    },
    FadeInCSS
);

interface TransitionElementProps extends TransitionProps {
    transition: TransitionName;
}

const TransitionElement = styled.div<TransitionElementProps>`
    ${(props) => getTransitionStyles(props.transition)}
`;

interface Props extends TransitionProps {
    children: React.ReactNode;
    name: TransitionName;
}

const Transition = ({ name, ...other }: Props) => <TransitionElement transition={name} {...other} />;

export default Transition;
